import * as React from 'react';

import PropTypes from 'prop-types';

export class PercentStat extends React.Component {
    static propTypes = {
        value: PropTypes.shape({
            value: PropTypes.number.isRequired,
            prefix: PropTypes.string.isRequired,
            suffix: PropTypes.string.isRequired,
            formatted: PropTypes.string.isRequired,
        }).isRequired,
        precision: PropTypes.number,
    };

    static defaultProps = {
        value: 0,
        precision: 1,
    };

    render() {
        return <div>{Number(this.props.value.formatted).toFixed(this.props.precision)}%</div>;
    }
}
